import { lazy } from "react";
import { CreditCard } from "lucide-react";
import type { AreaRoutes } from "./types";

const Signup = lazy(() => import("../pages/auth/Signup"));
const Login = lazy(() => import("../pages/auth/Login"));
const Verify = lazy(() => import("../pages/auth/Verify"));
const Welcome = lazy(() => import("../pages/auth/Welcome"));
const Billing = lazy(() => import("../pages/Billing"));
const Admin = lazy(() => import("../pages/Admin"));

// Keep the bare paths in step with PUBLIC_PATHS in lib/standalone.ts.
export const billing: AreaRoutes = {
  routes: [
    { path: "/signup", element: <Signup />, bare: true },
    { path: "/login", element: <Login />, bare: true },
    { path: "/auth/verify", element: <Verify />, bare: true },
    { path: "/welcome", element: <Welcome />, bare: true },
    { path: "/billing", element: <Billing /> },
    // Operators only; no nav entry (the nav is the Rumio manifest's). Linked from the account menu.
    { path: "/admin", element: <Admin /> },
    { path: "/admin/:id", element: <Admin /> },
  ],
  nav: [{ to: "/billing", label: "Billing", icon: CreditCard }],
};
